@if (localProfileInitialization) {
  <div class="row justify-content-center">
    <div class="col-md-2">
      <div class="form-group">
        <label for="profileQty" class="control-label">Number of Local Profiles</label>
        <ng-select id="profileQty" [(ngModel)]="localProfileInitialization.NumberOfLocalProfiles" (ngModelChange)="onQtyChange()" [clearable]="false">
          <ng-option *ngFor="let qty of localProfileQtyNumbers" [value]="qty">{{ qty }}</ng-option>
        </ng-select>
      </div>
    </div>

    <div class="col-md-2">
      <div class="form-group">
        <label for="profileQtySub" class="control-label">Number of Subscriptions</label>
        <ng-select id="profileQtySub" [(ngModel)]="localProfileInitialization.NumberOfSubscriptions" [clearable]="false">
          <ng-option *ngFor="let qty of subscriptionQtyNumbers" [value]="qty">{{ qty }}</ng-option>
        </ng-select>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <label for="note" class="control-label">Notes for Fulfillment</label>
        <input type="text" class="form-control" [(ngModel)]="localProfileInitialization.Note" [disabled]="noteDisabled" [readOnly]="noteDisabled" maxlength="350" />
      </div>
    </div>
  </div>
} @else {
  <div class="text-center">Loading...</div>
}